module.exports = __webpack_public_path__ + "img/accessory_item_02.a16ad7b1.svg";